import request from "../../utils/request";

// 商品库统计---wx_shop/product/detail
export const getStatisticsDataList = (param, Authorization) => {
  return request({
    //url: '/chaoren',
    url: "/api/wx_shop/product/detail",
    method: "post",
    data: param,
    headers: {
      // "Content-Type":"application/x-www-form-urlencoded;charset-utf-8",
      authorization: Authorization,
    },
  });
};

// 券统计
export const getCouponDataList = (param, Authorization) => {
    return request({
      //url: '/chaoren',
      url: "/api/wx_shop/coupon/detail",
      method: "post",
      data: param,
      headers: {
        // "Content-Type":"application/x-www-form-urlencoded;charset-utf-8",
        authorization: Authorization,
      },
    });
  };

//   员工统计 getEmpDataList
export const getEmpDataList = (param, Authorization) => {
    return request({
      //url: '/chaoren',
      url: "/api/wx_shop/emp/detail",
      method: "post",
      data: param,
      headers: {
        // "Content-Type":"application/x-www-form-urlencoded;charset-utf-8",
        authorization: Authorization,
      },
    });
  };


/** 新商城 */
/** 商品统计 */
export const getProductDetailApi = (param, Authorization) => {
  return request({
    //url: '/chaoren',
    url: "/api/wx_shop/dataCenter/shopDetail",
    method: "post",
    data: param,
    headers: {
      // "Content-Type":"application/x-www-form-urlencoded;charset-utf-8",
      authorization: Authorization,
    },
  });
};


/** 活动统计 */
export const getActivityDetailApi = (param, Authorization) => {
  return request({
    //url: '/chaoren',
    url: "/api/wx_shop/activity/detail",
    method: "post",
    data: param,
    headers: {
      // "Content-Type":"application/x-www-form-urlencoded;charset-utf-8",
      authorization: Authorization,
    },
  });
};

/** 券统计 */
export const getCouponDetailApi = (param, Authorization) => {
    return request({
      //url: '/chaoren',
      url: "/api/wx_shop/activity/couponDetail",
      method: "post",
      data: param,
      headers: {
        // "Content-Type":"application/x-www-form-urlencoded;charset-utf-8",
        authorization: Authorization,
      },
    });
  };

  /** 检查新旧商城 0： 旧商城 1： 新商城 默认新商城 1 */

  export function checkMallSysApi(params,authorization,isloading = false){
    return request({
      url: `/api/wx_shop/checkMallSys?corpId=${params}`,
      method: 'get',
      params,
      headers: {
        "authorization": authorization
      }
    },isloading)
  }
